import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react/enhancers';
import { compose } from '@beef/utils';
import { getIsOrangeComboButtonEnabled, getIsTariffAccumsFttbDivideEnabled } from '@beef/elk-common/utils';
import { OrangeComboButton } from "../../../OrangeCombo";
import { Card } from "../../Card";
import { selectIsFTTBUser } from "../store/selectors";
import { Tariff } from "../Tariff";
import { AccumulatorsBlock } from "../AccumulatorsBlock";
import { ConvergentBlock } from "../components/ConvergentBlock";
var _Mobile = function _Mobile() {
  var showOrangeCombo = getIsOrangeComboButtonEnabled();
  return /*#__PURE__*/React.createElement(Card, {
    color: "primary",
    size: "m",
    "data-t-id": "ConnectionBlock-Mobile"
  }, /*#__PURE__*/React.createElement(Tariff, {
    "data-t-id": "ConnectionBlock-Mobile"
  }), /*#__PURE__*/React.createElement(AccumulatorsBlock, null), showOrangeCombo && /*#__PURE__*/React.createElement(OrangeComboButton, {
    showSkeleton: true
  }), /*#__PURE__*/React.createElement(ConvergentBlock, null));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    shouldRender: !selectIsFTTBUser(state) && getIsTariffAccumsFttbDivideEnabled()
  };
};
var connector = connect(mapStateToProps);
export var Mobile = compose(connector, withRenderFlag)(_Mobile);